/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {NavLink} from "react-router-dom";


import {Col} from "react-bootstrap";


import notificationIcon from "@Icons/notification.png";


type ApplicationHeaderComponentProps = {
    USER_NOTIFICATIONS: any;
};


export const ApplicationNotificationsComponent: React.FC<ApplicationHeaderComponentProps> = ({
    USER_NOTIFICATIONS = []
}): JSX.Element | null => {


    return (
        <Col xs={2} className={"application-notifications-component"}>
            <NavLink to={"/wiadomosci"} exact title={`Przejdź do skrzynki odbiorczej`} className={"mailbox-link"}>
                <img src={notificationIcon} alt={`Skrzynka odbiorcza`} />
                <span className={"messages-number"}>{USER_NOTIFICATIONS.length}</span>
            </NavLink>
        </Col>
    );

}


export default ApplicationNotificationsComponent;
